import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SortingOrderType } from 'src/app/interfaces/search.interface';
import { SortCategories, SortOptions } from './sort-drop-down.helpers';

@Component({
  selector: 'app-sort-drop-down',
  templateUrl: './sort-drop-down.component.html',
  styleUrls: ['./sort-drop-down.component.scss'],
})
export class SortDropDownComponent {
  @Input({ required: true }) public isLoading: boolean;
  @Input({ required: true }) public ascending: boolean;
  @Input({ required: true }) public currentSortCategory: SortingOrderType;
  @Input({ required: true }) public sortOptions: SortOptions[];

  @Output() public toggleSortingByType: EventEmitter<SortOptions> = new EventEmitter<SortOptions>();

  public sortCategoriesByType: typeof SortCategories = SortCategories;

  public nameTypeSorting = 'SORT_BY_SCORE';
  public currentSortCategoryByType: SortCategories = SortCategories.SCORE_DESC;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['ascending'] || changes['currentSortCategory']) {
      this.setSortParams();
    }
  }

  public toggleSortingOrderByType(sortCategory: SortCategories, nameTypeSorting: string): void {
    this.toggleSortingByType.emit({
      sortCategory,
      sortTitle: nameTypeSorting,
    });
  }

  private setSortParams(): void {
    switch (true) {
      case this.currentSortCategory === SortingOrderType.NAME && this.ascending:
        this.nameTypeSorting = 'SORT_BY_A_Z';
        this.currentSortCategoryByType = SortCategories.NAME_ASC;
        break;

      case this.currentSortCategory === SortingOrderType.NAME && !this.ascending:
        this.nameTypeSorting = 'SORT_BY_Z_A';
        this.currentSortCategoryByType = SortCategories.NAME_DESC;
        break;

      case this.currentSortCategory === SortingOrderType.DATE && this.ascending:
        this.nameTypeSorting = 'SORT_BY_OLDEST';
        this.currentSortCategoryByType = SortCategories.DATE_ASC;
        break;

      case this.currentSortCategory === SortingOrderType.DATE && !this.ascending:
        this.nameTypeSorting = 'SORT_BY_NEWEST';
        this.currentSortCategoryByType = SortCategories.DATE_DESC;
        break;

      case this.currentSortCategory === SortingOrderType.SCORE && !this.ascending:
        this.nameTypeSorting = 'SORT_BY_SCORE';
        this.currentSortCategoryByType = SortCategories.SCORE_DESC;
        break;
    }
  }
}
